import { PropsWithChildren } from 'react';
import { StyleSheet, View, ViewProps, ViewStyle } from 'react-native';

import { colors } from '../../theme';
import { Text } from '../Text';

const MAX_VALUE = 99;

interface Props {
	invisible?: boolean;
	value?: number | string;
	style?: ViewStyle;
	badgeStyle?: ViewStyle;
	containerStyle?: ViewStyle;
	fullWidth?: boolean;
	testID?: ViewProps['testID'];
}

export const Badge = ({
	children,
	invisible,
	value,
	style,
	badgeStyle,
	fullWidth,
	containerStyle,
	testID,
}: PropsWithChildren<Props>) => {
	const displayedValue = value
		? typeof value === 'string'
			? value
			: value > MAX_VALUE
				? `${MAX_VALUE}+`
				: `${value}`
		: '';

	return (
		<View style={[fullWidth && styles.fullWidth, containerStyle]} testID={testID}>
			<View style={style}>{children}</View>
			{!invisible && (
				<View
					style={[
						styles.badge,
						value ? styles.valueBadge : undefined,
						{
							marginRight: displayedValue.split('').length * -1.25,
						},
						badgeStyle,
					]}
				>
					<Text style={styles.text} testID={`${testID}/value`}>
						{displayedValue}
					</Text>
				</View>
			)}
		</View>
	);
};

const DOT_SIZE = 11;
const styles = StyleSheet.create({
	fullWidth: {
		flex: 1,
	},
	badge: {
		position: 'absolute',
		top: -2,
		right: -2,
		height: DOT_SIZE,
		minWidth: DOT_SIZE,
		borderRadius: DOT_SIZE,
		backgroundColor: colors.primary700,
	},
	valueBadge: {
		height: 'auto',
		minHeight: DOT_SIZE,
		marginTop: -6,
		paddingVertical: 1,
		paddingHorizontal: 4,
	},
	text: {
		fontSize: 10,
		paddingHorizontal: 1,
		color: colors.white,
	},
});
